export const plano = {
    namespaced: true,
    state: {
        groups: [],
        dividers: []
    },

    getters: {
        getGroups(state) {
            return state.groups;
        },

        getDividers(state) {
            return state.dividers;
        },

        getGroupByModule: state => mod => {
            let groups = state.groups.filter(g => g.modules.filter(m => m.UUID === mod.UUID).length > 0);
            return groups.length === 0 ? null : groups[0];
        },

        getGroupByShelf: state => shelf => {
            let groups = state.groups.filter(g => g.component.UUID === shelf.UUID);
            return groups.length === 0 ? null : groups[0];
        }
    },

    mutations: {
        ADD_GROUP(state, group) {
            state.groups.push(group);
        },

        ADD_DIVIDER(state, divider) {
            state.dividers.push(divider);
        },

        ADD_MODULE_TO_GROUP(state, object) {
            if (!object.group.modules) object.group.modules = [];
            object.group.modules.push(object.module);
        },

        DELETE_MODULE_TO_GROUP(state, module) {
            let groups = state.groups;
            let group = groups.find(g => {
                return g.modules.filter(m => module.UUID === m.UUID).length > 0;
            });

            if (group) {
                group.modules.splice(group.modules.indexOf(module), 1);
            }
        },

        DELETE_GROUP(state, group) {
            state.groups.splice(state.groups.indexOf(group), 1);
        },

        CLEAN_STATE(state) {
            state.groups = [];
            state.dividers = [];
        }
    },

    actions: {
        addGroup(context, group) {
            context.commit("ADD_GROUP", group);
        },

        addDivider(context, divider) {
            context.commit("ADD_DIVIDER", divider);
        },

        addModuleToGroup(context, object) {
            context.commit("ADD_MODULE_TO_GROUP", object);
        },

        deleteModuleToGroup(context, module) {
            context.commit("DELETE_MODULE_TO_GROUP", module);
        },

        deteleGroup(context, group) {
            context.commit("DELETE_GROUP", group);
        },

        cleanState(context) {
            context.commit("CLEAN_STATE");
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/planonext/plano.js